import React from "react";

/**
 * Props:
 * date
 * amount
 * code
 * redeemedDate
 */
const RewardTimelineItem = ({
  date,
  amount,
  code,
  redeemedDate
}) => {

  const parsedDate = new Date(date);
  const day = parsedDate.getDate();
  const month = parsedDate.toLocaleString("default", { month: "short" });

  const isRedeemed = redeemedDate && redeemedDate !== "N/A";

  return (
    <div className="reward-item d-flex">

      {/* LEFT DATE COLUMN */}
       <div className="timeline-left text-center me-3">
            <div className="timeline-dot" />
            <div className="timeline-date mb-2">
                <small className="text-muted d-block">{month.toUpperCase()}</small>
                <h6 className="mb-0">{day}</h6>
            </div>
       </div>

      {/* RIGHT CARD */}
      <div className="card p-3 flex-grow-1 reward-card">

        <div className="d-flex justify-content-between align-items-center">

          <div>
            <h6 className="mb-1 font-bold">
              Voucher Reward
            </h6>

            <p className="font8 text-muted mb-1">
              Code: <b>{code}</b>
            </p>

            <p className="font8 text-muted mb-0">
              Spending: <b>KES {Number(amount).toLocaleString()}</b>
            </p>
          </div>

          {/* STATUS */}
          <span className={`badge ${isRedeemed ? "bg-success" : "bg-warning text-dark"}`}>
            {isRedeemed ? "Redeemed" : "Active"}
          </span>

        </div>

      </div>

    </div>
  );
};

export default RewardTimelineItem;